import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'fdk-loading-dots',
  templateUrl: './loading-dots.component.html',
  styleUrl: './loading-dots.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    'aria-hidden': 'true',
  },
})
export class FdkLoadingDotsComponent {}
